/*
 * Main and demo navigation arrays
 * Each item can have a 'module' property that matches the Auth0 app_metadata.modules values
 * Items without a module property are always visible (e.g., Dashboard)
 */

export default {
        main: [
                {
                        name: 'Dashboard',
                        to: '/dashboard',
                        icon: 'si si-speedometer',
                },
                {
                        name: 'Shop',
                        icon: 'si si-shop',
                        subActivePaths: '/listeritem',
                        sub: [
                                {
                                        name: 'Badges',
                                        to: '/badges',
                                        module: 'Badges',
                                },
                                {
                                        name: 'Lister Items',
                                        to: '/listeritem',
                                        module: 'Lister Items',
                                },
                                {
                                        name: 'PDPs',
                                        to: '/pdp',
                                        module: 'PDPs',
                                },
                        ],
                },
                {
                        name: 'Promo',
                        icon: 'si si-megaphone',
                        subActivePaths: '/crosssell',
                        sub: [
                                {
                                        name: 'Cross Sell',
                                        to: '/crosssell',
                                        module: 'Cross Sell',
                                },
                                {
                                        name: 'Upsells',
                                        to: '/upsell',
                                        module: 'Upsells',
                                },
                                {
                                        name: 'Bulk Discount',
                                        to: '/discount-bulk',
                                        module: 'Bulk Discount',
                                },
                        ],
                },
                {
                        name: 'Products',
                        icon: 'si si-energy',
                        subActivePaths: '/backend/blocks',
                        sub: [
                                {
                                        name: '2D Models',
                                        to: '/model2d',
                                        module: '2D Models',
                                },
                                {
                                        name: '3D Models',
                                        to: '/model3d',
                                        module: '3D Models',
                                },
                                {
                                        name: 'Flex Group',
                                        to: '/flexgroup',
                                        module: 'Flex Group',
                                },
                                {
                                        name: 'Offering',
                                        to: '/offerings',
                                        module: 'Offering',
                                },
                                {
                                        name: 'Offering Option',
                                        to: '/offeringoption',
                                        module: 'Offering Option',
                                },
                                {
                                        name: 'Pricing',
                                        to: '/pricing',
                                        module: 'Pricing',
                                },
                                {
                                        name: 'Shipping',
                                        to: '/shipping',
                                        module: 'Shipping',
                                },
                        ],
                },
                {
                        name: 'Localisation',
                        icon: 'si si-globe',
                        subActivePaths: '/region',
                        sub: [
                                {
                                        name: 'Regions',
                                        to: '/region',
                                        module: 'Regions',
                                },
                                {
                                        name: 'Currencies',
                                        to: '/currency',
                                        module: 'Currencies',
                                },
                                {
                                        name: 'Countries',
                                        to: '/country',
                                        module: 'Countries',
                                },
                                {
                                        name: 'Hyperlinks',
                                        to: '/hyperlink',
                                        module: 'Hyperlinks',
                                },
                        ],
                },
                {
                        name: 'Design Assets',
                        icon: 'si si-picture',
                        subActivePaths: '/sticker',
                        sub: [
                                {
                                        name: 'Stickers',
                                        to: '/sticker',
                                        module: 'Stickers',
                                },
                                {
                                        name: 'Page Background',
                                        to: '/pagebg',
                                        module: 'Page Background',
                                },
                        ],
                },
                {
                        name: 'Themes',
                        icon: 'si si-fire',
                        subActivePaths: '/themecategories',
                        sub: [
                                {
                                        name: 'Photoframes',
                                        to: '/photoframe',
                                        module: 'Photoframes',
                                },
                                {
                                        name: 'Layouts',
                                        to: '/layout',
                                        module: 'Layouts',
                                },
                                {
                                        name: 'Category',
                                        to: '/themecategory',
                                        module: 'Category',
                                },
                                {
                                        name: 'Themes',
                                        to: '/themes',
                                        module: 'Themes',
                                },
                                {
                                        name: 'Templates',
                                        to: '/template',
                                        module: 'Templates',
                                },
                        ],
                },
                {
                        name: 'Discounts',
                        icon: 'si si-layers',
                        subActivePaths: '/discount',
                        sub: [
                                {
                                        name: 'Discount',
                                        to: '/discount',
                                        module: 'Discount',
                                },
                                {
                                        name: 'Discount Voucher',
                                        to: '/discount-voucher',
                                        module: 'Discount Voucher',
                                },
                        ],
                },
                {
                        name: 'Integrations',
                        icon: 'si si-organization',
                        subActivePaths: '/shop-integration',
                        sub: [
                                {
                                        name: 'Shops',
                                        to: '/shop-integration',
                                        module: 'Shop Integrations',
                                },
                        ],
                },
                {
                        name: 'Developer',
                        icon: 'si si-wrench',
                        subActivePaths: '/app-settings',
                        sub: [
                                {
                                        name: 'App Setting',
                                        to: '/appsetting',
                                        module: 'App Setting',
                                },
                                {
                                        name: 'API permission',
                                        to: '/application',
                                        module: 'API permission',
                                },
                        ],
                },
        ],
};
